import intl from "react-intl-universal";
import {
  TbBuildingBank,
  TbCreditCard,
  TbHistory,
  TbSettings,
  TbUser,
  TbWallet,
} from "react-icons/tb";

export const CUSTOMER_TABS = [
  { id: "profile", labelKey: "crossborder.customer.tabs.profile", icon: TbUser },
  { id: "wallets", labelKey: "crossborder.customer.tabs.wallets", icon: TbWallet },
  { id: "bankAccounts", labelKey: "crossborder.customer.tabs.bankAccounts", icon: TbBuildingBank },
  { id: "virtualAccounts", labelKey: "crossborder.customer.tabs.virtualAccounts", icon: TbCreditCard },
  { id: "transactions", labelKey: "crossborder.customer.tabs.transactions", icon: TbHistory },
  { id: "settings", labelKey: "crossborder.customer.tabs.settings", icon: TbSettings },
];

const PLACEHOLDER_TABS = new Set(["wallets", "bankAccounts", "transactions", "settings"]);

export const CrossborderCustomerSidebar = ({ customer, activeTab, onTabChange }) => (
  <div className="flex flex-col gap-4">
    {customer ? (
      <div className="border-b border-gray-100 pb-3 dark:border-brand-dark-border">
        <p className="text-sm font-bold text-brand-dark dark:text-gray-100">{customer.label}</p>
        <p className="mt-0.5 truncate text-xs text-gray-500 dark:text-gray-400" title={customer.email}>
          {customer.email}
        </p>
      </div>
    ) : null}
    <nav className="flex flex-col gap-0.5">
    {CUSTOMER_TABS.map(({ id, labelKey, icon: Icon }) => {
      const isActive = activeTab === id;
      const isPlaceholder = PLACEHOLDER_TABS.has(id);

      return (
        <button
          key={id}
          type="button"
          onClick={() => onTabChange(id)}
          className={`flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-left text-sm transition ${
            isActive
              ? "bg-brand-cream font-semibold text-[#9a7340] dark:bg-brand-dark-elevated dark:text-brand-gold-mid"
              : "text-gray-600 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-brand-dark-elevated/50"
          }`}
        >
          <Icon className="h-4 w-4 shrink-0" aria-hidden />
          <span className="min-w-0 flex-1 truncate">{intl.get(labelKey)}</span>
          {isPlaceholder ? (
            <span className="rounded bg-gray-100 px-1.5 py-0.5 text-[9px] font-semibold uppercase text-gray-400 dark:bg-brand-dark-elevated">
              {intl.get("nav.soon")}
            </span>
          ) : null}
        </button>
      );
    })}
    </nav>
  </div>
);
